import React, { useRef } from 'react';
import clsx from 'clsx';
import { apiService } from '../../services';

/**
 * 
 * @param {[]} props.pagesName - array with all names of current project 
 * @param {[][]} props.projectNamesPages - 2d array with all page names of all projects
 * @param {setState} props.setProjectNamesPages - hook function that updates projectNamesPages variable
 * @param {number} props.selectedPage - index of current page stored in localStorage
 * @param {number} props.selectedProject - index of current project stored in localStorage
 * @param {[][]} props.savedPagesPerProject - 2d array with save state of all pages of all projects
 * @param {setState} props.setSavedPagesPerProject - hook function that updates savedPagesPerProject array 
 * @param {method} props.changePagePerProjectTable - it is called when a page label is pressed
 * @param {setState} props.setSelectedPage - hook function that updates index of selected page
 * @returns component that renders the names of all project's pages in a horizontal row 
 */
const SelectPage = (props) => {

    const{
        pagesNames,
        projectNamesPages,
        setProjectNamesPages,
        selectedPage,
        selectedProject,
        savedPagesPerProject,
        setSavedPagesPerProject,
        changePagePerProjectTable,
        setSelectedPage
    }= props;

    const dragItem = useRef();  // Initialize dragItem with an empty ref object
    const dragOverItem = useRef(); // Initialize dragOverItem with an empty ref object

    // Function that updates dragItem's position on dragStart of a page button
    const dragStart = (e, position) => {
        dragItem.current = position;
    };

    // Function that updates dragOverItem's position on dragEnter of a page button
    const dragEnter = (e, position) => {
        dragOverItem.current = position;
    };

    /**
     * Function that is applied on dragEnd of a page button that has been dragged
     */
    const drop = () => {
        const copyProjectPageNames = [...projectNamesPages];

        // Change positions of page names between draged element and dragedOver element inside copyProjectNamesPages
        const dragItemContent = copyProjectPageNames[selectedProject][dragItem.current];
        copyProjectPageNames[selectedProject].splice(dragItem.current, 1);
        copyProjectPageNames[selectedProject].splice(dragOverItem.current, 0, dragItemContent);
       
        // Change positions of save status between draged element and dragedOver element inside copySavedPagesPerProject
        const copySavedPagesPerProject = [...savedPagesPerProject];
        const dragSavedPagedPerProjectContent = copySavedPagesPerProject[selectedProject][dragItem.current];
        copySavedPagesPerProject[selectedProject].splice(dragItem.current, 1);
        copySavedPagesPerProject[selectedProject].splice(dragOverItem.current, 0, dragSavedPagedPerProjectContent);

        // Change positions of pages names between draged element and dragOver element inside localStorage
        const tempData = JSON.parse(localStorage.getItem('data'));
        const tempPage = JSON.parse(localStorage.getItem('data'))[selectedProject].pages[dragItem.current];
        tempData[selectedProject].pages.splice(dragItem.current, 1);
        tempData[selectedProject].pages.splice(dragOverItem.current, 0, tempPage);
        
        // Update project with reorder pages 
        apiService.updateProject2(tempData[selectedProject]._id, {
            pages : tempData[selectedProject].pages.map(page => page.pageId)
        })
        .then( () => {
            localStorage.setItem('data', JSON.stringify(tempData));
            setProjectNamesPages(copyProjectPageNames);
            if(dragItem.current === selectedPage ){
                setSelectedPage(dragOverItem.current);
            }
            else if( dragOverItem.current === selectedPage){
                setSelectedPage(dragItem.current);
            }
            setSavedPagesPerProject(copySavedPagesPerProject); 
            dragItem.current = null;
            dragOverItem.current = null;

        })

    };


    return (
        <div id='pagesLabels' style={{whiteSpace: 'nowrap', overflowX: 'auto'}} className={clsx('overflow-style')}>
            { /* This check is true only inside build apps */ }
            { selectedProject > -1 && projectNamesPages !== undefined  &&
                projectNamesPages[selectedProject].map( (page,index) => {
                    if (index === selectedPage && page!==undefined) {
                        return(
                            <div 
                                id={`page${index}`} 
                                key={`page${page}`}
                                draggable 
                                onDragStart={(e) => dragStart(e, index)} 
                                onDragEnter={(e) => dragEnter(e, index)} 
                                className={clsx('selectedPageTabStyle','teamSelector')}
                                onDragEnd={drop}
                                onDragOver={(e) => e.preventDefault()}
                                aria-hidden="true"
                            >
                                <span className={clsx((index === 0 && 'fa'), (index === 0 && 'fa-home'))}>&nbsp;</span>
                                {page}{ savedPagesPerProject !== undefined && savedPagesPerProject[selectedProject][index] === false && <span>*</span>}
                            </div>
                        )
                    }
                    if(index !== selectedPage && page!== undefined){
                        return(
                        <div 
                            id={`page${index}`} 
                            key={`page${page}`}
                            draggable 
                            onDragStart={(e) => dragStart(e, index)} 
                            onDragEnter={(e) => dragEnter(e, index)} 
                            onClick={() => changePagePerProjectTable(index)} 
                            className={clsx('pagesTabsStyle','teamSelector')}
                            onDragEnd={drop}
                            onDragOver={(e) => e.preventDefault()}
                            aria-hidden="true"
                        >
                            <span className={clsx((index === 0 && 'fa'), (index === 0 && 'fa-home'))}>&nbsp;</span>
                            {page} 
                        </div>
                        )
                    }
                    return page;
                })
            }
            { /* This check is true in pages outside build apps */}
            {selectedProject > -1 && pagesNames !== undefined &&
                pagesNames.map( (page,index) => 
                    (
                        <div 
                            onClick={() => changePagePerProjectTable(index)} 
                            className={clsx((selectedPage === index ? 'selectedPageTabStyle' : 'pagesTabsStyle'),'teamSelector')}
                            aria-hidden="true"
                        >
                            {page} 
                        </div>)
                )
            }
        </div>        
    )
}

export default SelectPage;